<style lang="scss" scoped>
.flex {
  display: flex;
}
.block {
  width: 677px;
  height: 499px;
  background: #f4f4f4;
  padding: 40px 30px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  .line {
    margin-top: 30px;
    > label {
      width: 120px;
      display: inline-block;
    }
  }
}
.block2 {
  flex: 1;
  margin-left: 22px;
}
.el-input {
  width: 475px;
}
.tip {
  color: #173bcf;
  margin: 10px 0 10px 120px;
  > span {
    display: inline-block;
    margin-right: 20px;
  }
}
.btn {
  margin-left: 120px;
  color: #173bcf;
  line-height: 20px;
  .plus {
    margin-right: 4px;
  }
}
.erweima {
  width: 300px;
  height: 300px;
  background: #000;
  margin: auto;
  > img {
    width: 100%;
    height: 100%;
  }
  + div {
    width: 300px;
    margin: auto;
  }
}
/deep/ {
  .el-dialog__body {
    padding: 0;
  }
  .el-checkbox {
    margin-top: 20px;
  }
}
.shaixuan {
  height: 45px;
  background: #606266;
  width: 100%;
  color: #fff;
  line-height: 45px;
  display: flex;
  > div:nth-child(1) {
    width: 80px;
    height: 100%;
    background: #17cfb8;
    text-align: center;
  }
  > div:nth-child(2) {
    flex: 1;
    height: 100%;
    justify-content: space-around;
    display: flex;
    margin-left: 35px;
    margin-right: 60px;
  }
}
.wrap {
  min-height: 500px;
  padding: 30px 20px;
  box-sizing: border-box;
}
.blue {
  color: #5e6166;
  display: inline-block;
  border: 1px solid #dcdfe6;
  padding: 10px 15px;
  > span {
    color: #0091ff;
    margin-left: 10px;
  }
}
</style>

<template>
  <div>
    <AlertTips color="#FEECB6" />

    <div class="flex clearfix mt30">
      <div class="block fl">
        <div>
          渠道名称
          <span v-if="show" class="ml20">{{form.name || 'sdsdsd'}}</span>
          <el-input v-else class="ml20" maxlength="20" v-model="form.name"></el-input>
        </div>
        <div class="line" v-if="showTags">
          <fans-label
            :disabled="show"
            :customTag="!!form.customTag"
            :customTags="[]"
            :id="id"
            @tagsChange="handlerTags"
            @changeChoose="val => form.customTag =  val ? 1 : 0"
          ></fans-label>
        </div>
        <div class="clearfix mt100" v-if="!show">
          <el-button class="fr mr50" type="primary" :disabled="!form.name" @click="submit">生 成</el-button>
        </div>
      </div>
      <div class="block block2" v-if="show">
        <div class="erweima">
          <img :src="url" alt />
        </div>
        <div class="alignr">右键保存二维码图片</div>
      </div>
    </div>
    <div class="clearfix mt30" v-if="show">
      <el-button class="fr" type="primary" @click="createOne">再建一个</el-button>
    </div>
  </div>
</template>

<script>
import fansLabel from '@/components/fansLabel';
import AlertTips from '@/components/alertTips';
import utils from '@/utils.js';

export default {
  components: {
    fansLabel,
    AlertTips,
  },
  computed: {},
  props: ['id'],
  watch: {
    'form.name': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 20) {
          this.form.name = oldval;
        }
      },
    },
  },
  data() {
    return {
      form: {
        name: '',
        customTag: 0,
      },
      url: '',
      show: false,
      dialogVisible: false,
      showTags: true,
    };
  },
  mounted() {},
  methods: {
    createOne() {
      this.showTags = false;
      this.show = false;
      this.form = {
        name: '',
        customTag: 0,
      };
      setTimeout(() => {
        this.showTags = true;
      }, 30);
    },
    handlerTags(val) {
      let ret = [];
      val.map(item => {
        ret.push(item.customTagId);
      });
      this.form.customtags = ret;
    },
    async submit() {
      if (!this.form.name) {
        this.$message.error('渠道名称未填写');
        return false;
      }
      let res = await this.$http.post(
        `/api/${this.id}/channel/args-qrcode`,
        this.form,
      );
      this.url = res.qrCodeUrl;
      this.show = true;
    },
  },
};
</script>
